/**
 * @fileoverview GET handler for the "/engagement/filter_groups" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementFilterGroups } from "./constants";
import type { EngagementFilterGroupsResult, FilterGroupsMode } from "./types";

export const getEngagementFilterGroups = reactQueryFetcherAdapter(
  engagementFilterGroups,
  (
    signal: AbortSignal,
    v2Format: boolean,
    availableFilters: FilterGroupsMode
  ): Promise<EngagementFilterGroupsResult> => {
    return fetch(
      "/engagement/filter_groups",
      "GET",
      {
        v2_format: v2Format,
        available_filters: availableFilters,
      },
      { signal }
    );
  }
);
